import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useNavHeight from 'hooks/useNavHeight';
import Wave from 'products/nomad_insurance/assets/img/waves/wave.svg';
import WaveMobile from 'products/nomad_insurance/assets/img/waves/wave-mobile.svg';
import { sizes } from 'style';
import { th } from 'style/theme';

const StyledHeaderBg = styled.div`
  position: sticky;
  top: ${({ navHeight }) => `${navHeight - 91}px`};
  width: 100vw;
  height: 170px;
  background-image: url(${WaveMobile});
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: ${th('colors.white')};
  margin-top: 55px;
  background-color: ${th('colors.white')};

  @media ${sizes.tabletPortrait} {
    height: 205px;
    top: ${({ navHeight }) => `${navHeight - 121}px`};
    background-image: url(${Wave});
  }

  @media ${sizes.desktop} {
    height: 195px;
    background-position: bottom;
    top: ${({ navHeight }) => `${navHeight - 90}px`};
    background-color: transparent;
  }

  @media ${sizes.extraLargeDesktop} {
    height: 210px;
  }
`;

const HeaderBg = ({ className }) => {
  const navHeight = useNavHeight();
  return <StyledHeaderBg navHeight={navHeight} className={className} />;
};

HeaderBg.propTypes = {
  className: PropTypes.string
};

export default HeaderBg;
